import { Stack, Typography, Box } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLocale } from "../../../../locales/localeSlice";

const Feature2Box = () => {
  const { t } = useTranslation();
  const currentLocale = useSelector(selectLocale);
  return (
    <Stack
      justifyContent={"center"}
      alignItems={"center"}
      paddingTop={2}
      spacing={5}
    >
      <Typography fontSize={{ md: "18px", xs: "14px" }} fontWeight={700}>
        {t("amazingFeatures.cardTwo.smallBox.title", {
          lng: currentLocale,
        })}
      </Typography>

      <Box component={"img"} src="/assets/icons/qr-code-svgrepo-com 1.png" />
    </Stack>
  );
};

export default Feature2Box;
